(function () {
    'use strict';

    angular.module("imApp").factory("forecastService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 856,
                    parameters: parms || {}
                });
            },
            listForecastTypes: function (parms) {
                return $ihttp.post({
                    method: 858,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 859,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
